import { LoadingOutlined } from '@ant-design/icons';
import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import {
  updateBrandingImage,
  uploadImage,
} from '../features/dashboard/actions';
import { isEmpty } from '../utils/helpers/helpers';
function useCoBranding(props) {
  const initBranding = props?.profile?.affiliationInfoImage?.link || '';
  const [imageUrl, setImageUrl] = useState(initBranding);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isEmpty(props?.profile?.affiliationInfoImage)) {
      setImageUrl(props?.profile?.affiliationInfoImage?.link || '');
    }
    // eslint-disable-next-line
  }, [props?.profile]);

  const uploadButton = <div>{loading && <LoadingOutlined />}</div>;
  const beforeUpload = (file) => {
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/png' ||
      file.type === 'image/jpg';
    if (!isJpgOrPng) {
      message.error('Ảnh phải là định dạng JPG, JPEG, hoặc PNG');
    }
    const maxUpload = file.size / 1024 / 1024 < 5;
    if (!maxUpload) {
      message.error('Ảnh không được vượt quá 5MB!');
    }
    return isJpgOrPng && maxUpload;
  };
  const handleUpload = async (file) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('config', 'GAME-PORTAL');
      props.actionShowLoading();
      const { data } = await uploadImage(formData);
      if (data.code === 200) {
        setImageUrl(data.data.publicUrl);
        const dataUpdate = await updateBrandingImage({
          url: data.data.publicUrl,
        });
        if (dataUpdate.data.code === 200) {
          props.actionGetProfile();
          message.success('Tải ảnh lên thành công!');
        }
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    } finally {
      setLoading(false);
      props.actionHideLoading();
    }
  };

  return {
    setImageUrl,
    handleUpload,
    beforeUpload,
    uploadButton,
    imageUrl,
    loading,
  };
}

export default useCoBranding;
